const initialState = null;

const ReservationIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationId":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationIdReducer;
